module.exports = __webpack_public_path__ + "static/media/Burndown chart.3f7331fd.svg";